import * as Term$SolvuuApi0 from "solvuu-api0/./term.bs.js";
var $$Event = Term$SolvuuApi0.$$Event;
var Events = Term$SolvuuApi0.Events;
var Get_by_id = Term$SolvuuApi0.Get_by_id;
var Get = Term$SolvuuApi0.Get;
var Create = Term$SolvuuApi0.Create;
var Mkdir = Term$SolvuuApi0.Mkdir;
var Get_events = Term$SolvuuApi0.Get_events;
export { $$Event, Events, Get_by_id, Get, Create, Mkdir, Get_events };
/* Term-SolvuuApi0 Not a pure module */